import $ from 'jquery'

/* @ngInject */
const mySelect = (
  $timeout,
  optionsHandler
) => {
  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      myOptions: '=',
      myDisabled: '=?',
      myData: '=',
      enableValidator: '=?',
    },
    template: require('./mySelect.html'),

    /* @ngInject */
    controller: ($scope) => {

    },
    link: {
      pre: (scope, element, attrs) => {
        const defaultOptions = {
          required: false,
          options: 'item as item.key for item',
          order: 'key.toString()',
          label: 'Selection',
        }
        const options = optionsHandler.setDefaults(scope.myOptions, defaultOptions)

        scope.required = false
        scope.selectOptions = options.options + ' in myData | orderBy:' + options.order
        scope.label = options.label

        if (scope.enableValidator) {
          scope.required = options.required
        }
      },
      post: (scope, element, attrs) => {
        scope.$watch('ngModel', (newValue, oldValue) => {
          if (newValue !== oldValue) {
            $timeout(() => {
              $('select.select-active').material_select()
            })
          }
        }, true)

        scope.$watch('myData', (newValue, oldValue) => {
          if (newValue !== oldValue) {
            $timeout(() => {
              $('select.select-active').material_select()
            })
          }
        }, true)

        $timeout(() => {
          $('select.select-active').material_select()
        })
      },
    },
  }
}

export default mySelect



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/mySelect.js